import { render, staticRenderFns } from "./voteList.vue?vue&type=template&id=29182e42&scoped=true&"
import script from "./voteList.vue?vue&type=script&lang=js&"
export * from "./voteList.vue?vue&type=script&lang=js&"
import style0 from "./voteList.vue?vue&type=style&index=0&id=29182e42&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29182e42",
  null
  
)

export default component.exports